import { showError } from "./messageAlerts";

// 🔹 Extract error message safely from FastAPI responses
const extractErrorDetail = (error) => {
  const data = error?.response?.data;

  if (!data) return "Network error — please check your connection.";

  const detail = data.detail;

  if (Array.isArray(detail)) {
    // Validation errors usually come as [{ msg: "..." }]
    return detail[0]?.msg || "Validation error occurred.";
  }

  if (typeof detail === "string") {
    // Standard single-string errors
    return detail;
  }

  if (typeof data.message === "string") {
    // Some backends return message instead of detail
    return data.message;
  }

  return "An unknown error occurred.";
};

// 🔹 Main API error handler
const handleApiError = (error) => {
  const status = error?.response?.status;
  const message = extractErrorDetail(error);

  if (status) {
    // Handle common FastAPI statuses
    // if (status === 404) {
    //   return;
    // }
    if ([400, 403, 409, 422, 404].includes(status)) {
      showError(message);
    } else if (status >= 500) {
      showError("Server error — please try again later.");
    } else {
      showError(message);
    }
  } else {
    showError(message);
  }
};

export default handleApiError;